import type { SlotItem } from "@recipevault/shared";

/**
 * Resolve a slot item's display label.
 *
 * `deriveTodayDigest` (and raw plan data) never carries recipe titles — recipe items are
 * just `{ kind: "recipe", recipeId }`, resolved here from the recipes Dexie store so the
 * UI never has to duplicate recipe data into the meal plan. Freetext items already carry
 * their own title.
 */
export function resolveItemLabel(item: SlotItem, recipeTitles: Map<string, string>): string {
  if (item.kind === "recipe") {
    return recipeTitles.get(item.recipeId) ?? "Recipe";
  }
  return item.title;
}
